export default function Impact(){



    return (
        <div>
            
        </div>
    )
}